// extracted by mini-css-extract-plugin
module.exports = {"storyPageContainer":"StoryPage_storyPageContainer__F01fj","storyPage":"StoryPage_storyPage__txaDV"};